<template>
  <DpplTooltip
    v-if="visible"
    class="translate-job-button my-auto"
    :class="{ 'ml-6': spaced }"
    :hide-tooltip="!disabled"
    tooltip-placement="bottom"
    teleport
  >
    <template #activator>
      <v-btn
        class="text-button-2 my-auto pa-0"
        variant="plain"
        data-testid="translate-job-button"
        :disabled="disabled"
        @click="open"
      >
        Translate
      </v-btn>
    </template>
    <template #tooltip-content>
      <p class="text-body-3">
        {{ tooltip }}
      </p>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import { useTranslateJobButton } from '@/composables/useTranslateJobButton';

defineProps({
  spaced: { type: Boolean, default: false },
});

const {
  visible, disabled, tooltip, open,
} = useTranslateJobButton();
</script>

<style scoped lang="less">
.translate-job-button {
  display: inline-flex;
  align-items: center;

  :deep(.activator) {
    display: inline-flex;
    align-items: center;
  }
}
</style>
